import { useVideoStore } from "./store/use-videos-store";
import { VideoPageLayout } from "../../../../libs/shared";
import VideoCajas from "./video-cajas";
import VideoCierreContenedor from "./video-cierre-contenedor";
import VideoCajasRecorder from "./video-cajas-recorder";
import VideoCierreRecorder from "./video-cierre-recorder";

const VideoPageComponent = () => {
  const container = useVideoStore((state) => state.container);
  const setContainer = useVideoStore((state) => state.setContainer);

  return (
    <VideoPageLayout
      title="Videos Contenedor Full"
      subtitle="Carga de video de cajas y cierre de contenedor"
      container={container}
      onContainerChange={setContainer}
      selectContent={
        <>
          <VideoCajas />
          <VideoCierreContenedor />
        </>
      }
      recordContent={
        <>
          <VideoCajasRecorder />
          <VideoCierreRecorder />
        </>
      }
    />
  );
};

export default VideoPageComponent;
